import React from 'react';
import { Paper } from '@mui/material';
import CompanyMenuItem from '../CompanyMenuItem';
import { DropDownProps } from './DropDown.props';
import { classes, Root } from './DropDown.styles';



const DropDown = ({ handleDropDown, dropDownRef, subMenuItem, open }: DropDownProps) => (
  <Root>
    {open && (
      <Paper square id="company-dropdown" className={classes.dropdown} elevation={7} ref={dropDownRef as any}>
        {subMenuItem?.subMenu?.map(option => (
          <CompanyMenuItem
            key={option.id}
            handleDropDown={handleDropDown}
            option={option}
            subMenuItem={subMenuItem}
          />
        ))}
      </Paper>
    )}
  </Root>
);

export default DropDown;
